module.exports = __webpack_public_path__ + "src/assets/img/$30-million.68c9f013.svg";